export const MIXPANEL_PAGE_VIEW_DATA_ID = 'mixpanel-view-data';
